module.exports = __webpack_public_path__ + "img/ped-logo.6994aac2.png";